<template>
  <div id="app">
    <router-view />
    <!-- <attachment-list/> -->
    <ZipDownloadProgress />
  </div>
</template>

<script>
  import ZipDownloadProgress from "@/components/zip-download-progress/zip-download-progress";

  export default {
    name: "App",
    components: {
      ZipDownloadProgress,
    },
  };
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
